import type { BadgeTone } from '@/shared/components/ui/badge'

// Тона дизайн-системы, а не свои hex: они уже согласованы со светлой и тёмной темой.
const TAG_TONES: BadgeTone[] = ['brand', 'success', 'warning', 'danger', 'info', 'neutral']

export function normalizeTagName(name: string): string {
  return name.trim().replace(/\s+/g, ' ').toLowerCase()
}

/** Детерминированный цвет тега по имени: в БД цвет не хранится. */
export function tagTone(name: string): BadgeTone {
  const normalized = normalizeTagName(name)
  let hash = 0

  for (let index = 0; index < normalized.length; index += 1) {
    hash = (hash * 31 + normalized.charCodeAt(index)) >>> 0
  }

  return TAG_TONES[hash % TAG_TONES.length]
}
